import { Dayjs } from "dayjs";
import { AssignToDataItem } from "./botApplicationInstance";
import { AssignedTypeEnum } from "./shared";

export interface TextEntryPoint {
	id?: string;
	identifier: string;
	name: string;
	email?: string;
	queueId?: string;
	flowId?: string;
	assignedMediaName?: string;
	type?: TypeEnum;
	accessToken?: string;
	businessAccountId: string;
	phoneNumber?: string;
	phoneNumberId?: string;
	url?: string;
	processingStartDate: string;
	folders: EmailFolder[];
}

export interface WebchatEntryPoint extends TextEntryPoint {
	acsEndpoint?: string;
	acsKey?: string;
	hostingDomain?: string;
	darkModePrimaryColor: string;
	darkModeSecondaryColor: string;
	lightModePrimaryColor: string;
	lightModeSecondaryColor: string;
	logo: string;
	oldLogo?: string;
	welcomeMessage: string;
	requestEmail: boolean;
	requireEmail: boolean;
	requestName: boolean;
	requireName: boolean;
	topicName: string;
	agentDisplayName: string;
	script?: string;
	component?: string;
	webhookUrl?: string;
	previewUrl?: string;
	callingApplicationInstanceId?: string;
	callingEnabled?: boolean;
	agentCallingEnabled?: boolean;
	customFields?: WebChatEntryPointCustomField[];
	showAgentName?: boolean;
}

export interface WebChatEntryPointCustomField {
	id?: string;
	entryPointId?: string;
	name: string;
	isRequired: boolean;
}

export interface EmailFolder {
	id?: string;
	name: string;
}

export const TextEntryPointAssignedTypeToLabelMapping: Record<
	AssignedTypeEnum,
	string
> = {
	[AssignedTypeEnum.Queue]: "TextEntryPoint.Queue",
	[AssignedTypeEnum.Flow]: "TextEntryPoint.Flow",
};

export interface EntryPointAssignments {
	queues: AssignToDataItem[];
	flows: AssignToDataItem[];
}

export enum TypeEnum {
	Email = 2,
	WhatsApp = 3,
	Webchat = 4,
}

export interface EmailEntryPointMappingsSectionProps
	extends EmailEntryPointMappingsContainerProps {
	propertyName: string;
}

export interface EmailEntryPointMappingsContainerProps {
	handleChange: any;
	touched: any;
	errors: any;
	handleBlur: any;
	folders: EmailFolder[];
	processingStartDate: Dayjs;
}

export interface WebchatEntryPointCustomizationMappingsContainerProps {
	handleChange: any;
	touched: any;
	errors: any;
	handleBlur: any;
	darkModePrimaryColor: string;
	darkModeSecondaryColor: string;
	lightModePrimaryColor: string;
	lightModeSecondaryColor: string;
	logo: string;
	welcomeMessage: string;
	requestEmail: boolean;
	requireEmail: boolean;
	requestName: boolean;
	requireName: boolean;
	topicName: string;
	agentDisplayName: string;
	customFields?: WebChatEntryPointCustomField[];
	showAgentName?: boolean;
}

export interface WebchatEntryPointCallingMappingsContainerProps {
	handleChange: any;
	touched: any;
	errors: any;
	callingEnabled: boolean;
	callingApplicationInstanceId: string;
	agentCallingEnabled: boolean;
}

export interface WebchatEntryPointSetupMappingsContainerProps {
	script: string;
	component: string;
	webhookUrl: string;
	previewUrl?: string;
	dirty: boolean;
	isSubmitting: boolean;
}

export interface WebChatCustomFieldsError {
	customFields: WebChatEntryPointCustomField[];
}

export interface WebchatEntryPointLogoUploadProps {
	fileName?: string;
	onFileChange: (fileName: string) => void;
}
